var exports = {
  "Qs": "CameraPreviewModal.module__content___SFp5eG",
  "Wc": "CameraPreviewModal.module__backgroundSection___SFp5eG",
  "Pz": "CameraPreviewModal.module__backgroundLabel___SFp5eG",
  "Ip": "CameraPreviewModal.module__effectStrengthSlider___SFp5eG",
  "TM": "CameraPreviewModal.module__effectStrengthLabelRow___SFp5eG",
  "dI": "CameraPreviewModal.module__effectStrengthLabel___SFp5eG",
  "j": "CameraPreviewModal.module__videoContainer___SFp5eG",
  "qr": "CameraPreviewModal.module__footer___SFp5eG",
  "wu": "CameraPreviewModal.module__footerStart___SFp5eG",
  "Dr": "CameraPreviewModal.module__footerMirrorSwitch___SFp5eG",
  "Ki": "CameraPreviewModal.module__video___SFp5eG",
  "Lw": "CameraPreviewModal.module__overlay___SFp5eG",
  "um": "CameraPreviewModal.module__overlayText___SFp5eG",
  "nU": "CameraPreviewModal.module__overlayTextMedium___SFp5eG",
  "$q": "CameraPreviewModal.module__errorOverlay___SFp5eG",
  "kc": "CameraPreviewModal.module__errorText___SFp5eG",
  "JU": "CameraPreviewModal.module__errorTitle___SFp5eG",
  "m2": "CameraPreviewModal.module__errorDetail___SFp5eG",
};

module.exports = exports;
